var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 48,
    viewBox: "0 0 39 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D6DADF",
    d: "M0 4.966h33.103V48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFBFC",
    d: "M38.069 6.62v36.414H4.966V0h26.482z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#01A36D",
    cx: 26.483,
    cy: 31.448,
    r: 8.276
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.655 5.793H17.38a.828.828 0 0 1 0-1.655h8.276a.828.828 0 1 1 0 1.655z",
    fill: "#E7B6A1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6DADF",
    d: "M38.069 6.62h-6.62V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.448 10.759H14.897a.828.828 0 0 1 0-1.656h16.551a.828.828 0 0 1 0 1.656zM25.655 20.69H9.931a.828.828 0 0 1 0-1.656h15.724a.828.828 0 1 1 0 1.656zM19.034 15.724H9.931a.828.828 0 1 1 0-1.655h9.103a.828.828 0 0 1 0 1.655zM33.103 20.69h-4.137a.828.828 0 1 1 0-1.656h4.137a.828.828 0 1 1 0 1.656zM17.38 25.655H9.93a.828.828 0 0 1 0-1.655h7.448a.828.828 0 0 1 0 1.655zM14.897 30.62H9.93a.828.828 0 0 1 0-1.654h4.966a.828.828 0 0 1 0 1.655zM15.724 35.586H9.931a.828.828 0 0 1 0-1.655h5.793a.828.828 0 1 1 0 1.655zM33.103 15.724H22.345a.828.828 0 1 1 0-1.655h10.758a.828.828 0 0 1 0 1.655z",
    fill: "#E7B6A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 35.586a.83.83 0 0 1-.689-.368l-1.655-2.483a.828.828 0 1 1 1.377-.918l1.096 1.643 5.906-5.907a.828.828 0 0 1 1.17 1.17l-6.62 6.62a.828.828 0 0 1-.585.243z",
    fill: "#E9EEF2"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.32f5f07e47ba884f561f5a33a2550511.svg";
export { ForwardRef as ReactComponent };